export default "__VITE_ASSET__C_GIZN2M__"